
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Notice',
  props: {
    enabled: {
      type: Boolean,
      default: true
    }
  }
})
